<template>
  <div class="page-home">
    <rebuild-nav-bar></rebuild-nav-bar>
    <div class="kv">
      <img src="~@static/funding_cpunk/home/kv.jpg" alt="" width="100%" />
      <img src="~@static/funding_cpunk/home/cyberpunk_gif.gif" class="btn" width="100%" @click="bindToCreation" />
    </div>
    <div class="field_wrapper">
      <div class="sa">
        <img src="~@static/funding_cpunk/home/num.png" alt="" width="100%" />
        <div class="num">{{ total_count }}</div>
      </div>
      <!-- plan1 -->
      <div class="plan1" v-if="specialPlan.id">
        <div class="tit">
          <img src="~@static/funding_cpunk/home/t1.png" />
        </div>
        <project-item
          :projectData="specialPlan"
          :hasTags="false"
          :hasDesc="false"
          :hasProcess="true"
          :hasLink="true"
          :hasTheme="true"
          :isAnnouncement="false"
          :isWeekly="false"
        >
        </project-item>
      </div>
      <!-- plan2 -->
      <div class="plan2">
        <div class="tit">
          <img src="~@static/funding_cpunk/home/t2.png" />
        </div>
        <div class="filter-bar" @click="handleClickItem">
          <img src="~@images/regular/funding/icon-location.png" class="pin-icon" />
          <div class="text">全国</div>
          <img src="~@images/regular/funding/icon-arrow-white.png" class="icon" />
        </div>
        <!-- panel-body -->
        <div class="panel-body" v-if="plansNew.length > 0">
          <swiper class="projects-list" :options="swiperOption">
            <swiper-slide class="project-item" v-for="item of plansNew" :key="item.id">
              <project-item
                :projectData="item"
                :hasTags="true"
                :hasDesc="false"
                :hasProcess="true"
                :hasLink="true"
                :hasTheme="true"
                :isAnnouncement="false"
                :isWeekly="false"
              >
              </project-item>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!--  -->
        <div class="panel-footer" v-if="plansNew.length > 0">
          <span class="text" @click="bindToPlansNew()">更多新鲜夜计划+</span>
        </div>
        <div class="panel-body no-data" v-if="plansNew.length == 0">
          <img src="~@static/funding/mb/no-data-txt.png" width="100%" />
        </div>
      </div>
      <!-- 造1 -->
      <div class="create_btn_s1" @click="bindToCreation"># 造一个夜计划 #</div>
      <div style="height: 58px"></div>
    </div>
    <fill-modal :isShow.sync="isShow" @confirm="fillModalConfirm" :maskClick="true">
      <div class="profile-datepicker">
        <div class="modal-title">请选择你所在的省份</div>
        <div class="datepicker-wrap">
          <van-picker item-height="7.4666vw" :columns="columns" columns-num="2" visible-item-count="3" @change="handleCityChange" />
        </div>
      </div>
    </fill-modal>
  </div>
</template>

<script>
import RebuildNavBar from '@components/RebuildNavBar'
import cityJs from '@javascripts/cities.js'
import FillModal from '../components/FillModal'
import ProjectItem from '../components/ProjectItemCpunk'
import { verify } from '@/utils'
export default {
  data() {
    return {
      isShow: false,
      columns: [],
      selectProvince: ['河北省', '石家庄市'],
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      plansNew: [],
      specialPlan: {},
      total_count: 0,
    }
  },
  components: {
    RebuildNavBar,
    FillModal,
    ProjectItem,
  },
  mounted() {
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png',
      }
      this.WXConfig.wxShowMenu(window.location.href, shareInfo)
    }
    //city
    let mapData = []
    cityJs.citiesData.provinces.forEach(item => {
      let obj = {
        text: item.provinceName,
        children: item.citys.map(item2 => {
          return {
            text: item2.citysName,
          }
        }),
      }
      mapData.push(obj)
    })
    this.columns = mapData
    this.getNewData()
    this.getNewDataB()
    this.requestStatistics()
  },
  methods: {
    getNewData() {
      this.$request
        .get(this.$apiConfig.newPlansUrl, {
          params: {
            per_page: 3,
            plan_status: 0,
            new: 1,
          },
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            this.plansNew = resData.data.items
          }
        })
    },
    getNewDataB() {
      this.$request.post(this.$apiConfig.cyberShow).then(res => {
        let resData = res.data
        if (resData.code == 0 && resData.data) {
          this.specialPlan = resData.data
          this.specialPlan.picture = this.specialPlan.picture[0]
        }
      })
    },
    requestStatistics() {
      this.$request.get(this.$apiConfig.planStatisticsUrl).then(res => {
        let resData = res.data
        if (resData.code == 0 && resData.data) {
          const _resData = resData.data
          this.total_count = _resData.total_count
        }
      })
    },
    handleCityChange(picker, value, index) {
      this.selectProvince = value
    },
    fillModalCancel() {},
    fillModalConfirm() {
      this.$router.push(`/fundingnew/explore?province=${this.selectProvince[1]}`)
    },
    handleClickItem() {
      this.isShow = true
    },
    bindToCreation(to) {
      this.$router.push('/fundingnew/creation')
      // _jcq.push(['_track', 'yjhbccreate'])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc5' })
    },
    bindToPlansNew(to) {
      this.$router.push('/fundingnew/explore')
      // _jcq.push(['_track', 'yjhbcinfomore_check'])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc4' })
    },
  },
  beforeRouteEnter(to, from, next) {
    // vue内部无法长按识别二维码
    const location = global.location
    const u = navigator.userAgent
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isiOS && to.path !== location.pathname) {
      // 此处不能使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.page-home {
  padding-bottom: 60px;
  @include respond-to(iphonex) {
    padding-bottom: 85px;
  }
}
.kv {
  position: relative;
  .btn {
    position: absolute;
    left: 0;
    top: pxtow(678);
    width: 100%;
  }
}
.field_wrapper {
  background: url(~@static/funding_cpunk/home/bg.jpg) no-repeat 0 0;
  background-size: 100% auto;
  padding-top: pxtow(116);
}
.sa {
  position: relative;
  .num {
    position: absolute;
    left: pxtow(0);
    top: pxtow(610);
    width: 100%;
    line-height: 1;
    text-align: center;
    font-family: 'AbsolutHeadline';
    font-size: pxtow(120);
    font-weight: bold;
    color: #fff;
    letter-spacing: 2px;
  }
}
.plan1 {
  margin-top: pxtow(140);
  .tit {
    margin-left: pxtow(46);
    margin-bottom: pxtow(50);
    img {
      width: pxtow(613);
    }
  }
}
.plan2 {
  margin-top: pxtow(160);
  .tit {
    margin-left: pxtow(46);
    margin-bottom: pxtow(30);
    img {
      width: pxtow(549);
    }
  }
  .filter-bar {
    width: pxtow(650);
    height: pxtow(75);
    padding: 0 pxtow(20);
    white-space: nowrap;
    box-sizing: border-box;
    border-radius: pxtow(40);
    margin: 0 auto pxtow(24);
    background: #fd0fff;
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    .pin-icon {
      width: pxtow(22);
      height: pxtow(22);
      margin-right: pxtow(10);
    }
    .text {
      flex: 1;
      margin-right: pxtow(20);
      font-size: pxtow(28);
      color: #fff;
      font-weight: 700;
    }
    .icon {
      width: pxtow(20);
      margin-right: pxtow(10);
    }
  }
  .panel-footer {
    font-size: (22/7.5) * 1vw;
    text-align: center;
    span {
      padding: (10/7.5) * 1vw;
    }
  }
}
.field_wrapper .create_btn_s1 {
  margin-top: pxtow(80);
}

.projects-list {
  padding-bottom: pxtow(66);
}
/deep/ .swiper-pagination {
  bottom: 10px;
}
/deep/ .swiper-pagination-bullet {
  width: 4px;
  height: 4px;
  margin: 0 3px;
  border-radius: 2px;
  background-color: nth($white, 1);
  overflow: hidden;
  opacity: 0.5;
}
/deep/ .swiper-pagination-bullet-active {
  background-color: nth($white, 1);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/index/index.vue